// Jun 2026 · Glossary favorites — starred terms a founder keeps forgetting.
// localStorage set shared by the Glossary page; starred terms float to the
// top of the A-Z list so they're always one glance away.
const KEY = "tlb_glossary_favorites_v1";

export function getGlossaryFavorites() {
  try {
    return JSON.parse(window.localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

export function toggleGlossaryFavorite(term) {
  if (!term) return getGlossaryFavorites();
  try {
    const list = getGlossaryFavorites();
    const next = list.includes(term)
      ? list.filter((t) => t !== term)
      : [...list, term];
    window.localStorage.setItem(KEY, JSON.stringify(next));
    return next;
  } catch {
    return getGlossaryFavorites();
  }
}
